// extracted by mini-css-extract-plugin
export default {"experience":"FL3GZhwWLAMrhQ362ULe","experienceText":"dV8ksoT12QdbBmh8_6g7","workingDate":"tKockPm4XtoWN5DVse4i"};